import { ref } from 'vue';

// The shift switcher's *value* lives in the dashboard query params (it's a
// FilterBar single-select), shared with every widget via the `filters` prop.
// Its *options* (labels + current shift) are data-derived, so the by-type widget
// publishes them here and the page header reads them to build the filter.
const shiftMeta = ref(null);

export function useComplianceShift() {
    return { shiftMeta };
}
